<template lang="pug">
    div
        Steps(:current="batchStep" style="margin-bottom: 20px")
            Step(v-for="(stepInfo, index) in batchStepData" :title="stepInfo.title" :content="stepInfo.content" :key="index")

        // 選擇要編輯的物件 
        component(
            v-show="batchStep == 0"
            :is="batchSelector"
            :selector="batchSelectorWith"
            v-model="batchSelectedData"
            v-bind="{givenSearchFilters: givenBatchSearchFilters}"
            :esIndex="esIndex"
            )

        // 使用者確認
        Row(v-show="batchStep == 1")
            Col
                Card
                    p(slot="title") Following domains will be deleted
                    p(v-for="item in batchSelectedData.selectedItems") {{ item }}

        // 功能鍵
        .footer
            Button(v-show="batchStep !== 0" style="width:45%" @click="changeBatchFormStep('prev')") Prev
            Button(v-if="batchStep !== 1" style="width:45%; float: right" @click="changeBatchFormStep('next')" :disabled="batchStepData[batchStep].isNextBtnDisabled()" ) Next
            Button(v-else style="width:45%; float: right" type="primary" @click="submitForm") {{ $t("rcmtable.submitText") }}
                
</template>
<script>
import FQDNSelector from "@/components/FQDNSelector.vue";

import { batchStepDataCompletion } from "@/libs/rcmTableFieldsFunction";
import { _batchDeleteData } from "@/api/esdata";

export default {
    components: {
        FQDNSelector
    },
    props: {
        esIndex: { type: String, default: "" },
        batchSelector: { type: String, default: "" },
        givenBatchSearchFilters: { type: Array, default: () => [] },
        batchSelectorWith: {}
    },
    data() {
        return {
            // 要批次修改的物件
            batchSelectedData: {
                selectedGroupName: "",
                selectedItems: []
            },

            batchStep: 0,
            batchStepData: [
                {
                    title: "Select Items",
                    content: "Select the items to delete",
                    isNextBtnDisabled: () => !this.hasSelectedItems
                },
                { title: "Confirm", content: "Confirm the changes" }
            ]
        };
    },
    created() {},
    mounted() {
        // 補上預設值
        this.initBatchStepData();
    },
    watch: {},
    methods: {
        initBatchStepData() {
            this.batchStepData = this.batchStepData.map(data => batchStepDataCompletion(data));
        },
        batchDeleteData(esIndex, formData, selectedItems) {
            _batchDeleteData(esIndex, formData, selectedItems)
                .then(result => {
                    this.$Notice.success({
                        title: this.$t("global.success"),
                        desc: `${result.data.message}`
                    });
                    this.$emit("batchDeleteSubmitComplete");
                })
                .catch(error => {
                    let errorObject = JSON.parse(JSON.stringify(error));
                    this.$Notice.warning({
                        title: this.$t("global.error"),
                        desc: `${error}`
                    });
                    this.$emit("batchDeleteSubmitComplete");
                });
        },
        async changeBatchFormStep(step) {
            if (step == "next") {
                // 執行驗證與 beforeNextStep 功能
                let passValidate = await this.batchStepData[this.batchStep].validateBeforeNextStep();
                console.log(passValidate);

                if (passValidate) {
                    this.batchStepData[this.batchStep].beforeNextStep();
                    this.batchStep += 1;
                }
            } else {
                this.batchStep -= 1;
            }

            // 執行 enter 功能
            this.batchStepData[this.batchStep].enter();
        },
        submitForm() {
            console.log("batchEditAction");
            this.batchDeleteData(
                this.esIndex,
                { groupName: this.batchSelectedData.selectedGroupName },
                this.batchSelectedData.selectedItems
            );
        }
    },
    computed: {
        hasSelectedItems() {
            return this.batchSelectedData.selectedItems.length !== 0;
        }
    }
};
</script>
<style lang="less" scoped>
.footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 15px 16px;
    text-align: left;
    background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/BatchDeleteForm.vue